let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aWPe2")).then(() => parcelRequire('bDxwy'));